import React, { ChangeEvent } from "react"
import styled from "styled-components"
import { generateSources } from "../../../helpers/images"
import { ResponsiveImage } from "../../../types"
import { Image } from "../../common/image.component"
import NavigationArrow from "../../common/navigation-arrow.component"
import { AppFunctionComponent } from "../../../types"
import { ScrollAnchor } from "../sections/custom/innovation-lab-form/innovation-lab.component"

const SelectedImageContainer = styled.div`
  position: relative;
`
const SelectedImage = styled(Image)`
  margin-bottom: 10px;
  height: 335px;
  border-radius: ${({ theme }) => theme.size.borderRadius};
  @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    height: 560px;
  }
`
const GallerySelect = styled.div`
  display: flex;
`
const GalleryOption = styled.label<{ active: boolean }>`
  margin-right: 10px;
  border-radius: ${({ theme }) => theme.size.borderRadiusSmall};
  border: 2px solid
    ${({ active, theme }) =>
      active ? theme.color.tag : theme.color.borderLight};
  width: 100%;
  max-width: 90px;
  display: block;

  input {
    display: none;
  }
`
const OptionImage = styled(Image)`
  height: 100%;
  width: 100%;
  max-width: 90px;
  max-height: 90px;
  margin: auto;
`
const RightNavigateButton = styled.button`
  position: absolute;
  right: 15px;
  top: calc(50% - (54px / 2));
  z-index: 3;
  border: none;
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.backgroundInverted};
  opacity: 1;
  transition: background-color 0.2s linear, opacity 0.2s linear;

  &:hover {
    background-color: ${({ theme }) => theme.color.background};
  }
  &:disabled {
    opacity: 0;
  }
  svg {
    width: 14px;
  }
`
const LeftNavigateButton = styled(RightNavigateButton)`
  right: unset;
  left: 15px;
`

interface Props {
  images: ResponsiveImage[]
  active: number
  anchorId?: string
  onActiveChange: (newValue: number) => void
}

const GalleryUI: AppFunctionComponent<Props> = ({
  className,
  images,
  active,
  onActiveChange,
  anchorId,
}) => {
  const previousDisabled = active === 0
  const nextDisabled = active === images.length - 1

  const onImageChange = (event: ChangeEvent<HTMLInputElement>) =>
    onActiveChange(parseFloat(event.target.value))
  const activatePrevious = () => onActiveChange(active - 1)
  const activateNext = () => onActiveChange(active + 1)

  return (
    <div className={className}>
      <ScrollAnchor id={anchorId} />
      <SelectedImageContainer>
        <LeftNavigateButton
          onClick={activatePrevious}
          disabled={previousDisabled}
        >
          <NavigationArrow type="left" title="Go left" />
        </LeftNavigateButton>
        <RightNavigateButton onClick={activateNext} disabled={nextDisabled}>
          <NavigationArrow type="right" title="Go right" />
        </RightNavigateButton>
        {images[active] && (
          <SelectedImage
            image={generateSources([
              [images[active].desktopImage],
              [images[active].tabletImage, 640],
              [images[active].mobileImage, 400],
            ])}
          />
        )}
      </SelectedImageContainer>
      <GallerySelect>
        {images.map((image, index) => (
          <GalleryOption key={index} active={index === active}>
            <OptionImage
              image={generateSources([
                [image.desktopImage],
                [image.tabletImage, 640],
                [image.mobileImage, 400],
              ])}
            />
            <input
              type="radio"
              value={index}
              name="product"
              onChange={onImageChange}
            />
          </GalleryOption>
        ))}
      </GallerySelect>
    </div>
  )
}

export default GalleryUI
